module.exports = __webpack_public_path__ + "img/screen_shot.12d71067.png";